export const getRoles = payload => {
    return {
        type: "GET_ROLES",
        payload: payload
    }
}

